<ds-card class="wallet-balance-card" [border]="true" [radius]="true" [surface]="'lowest'" [elevated]="false">
    <ds-card-content>
        <div class="wallet-balance-card__top">
            <div class="wallet-balance-card__top-left d-flex align-items-center">
                <span class="wallet-balance-card__title">{{ item.text }}</span>
            </div>
            <div class="wallet-balance-card__top-right d-flex align-items-center">
                <span class="wallet-balance-card__amount" [class.wallet-balance-card__txt-cautious]="balance < 0">
                    {{ balance | vnCurrency }}
                </span>
                @if (balance < 0) {
                    <vn-icon
                        class="wallet-balance-card__txt-info"
                        name="theme-info"
                        size="16"
                        [dsTooltipTriggerFor]="tooltip"
                        [closeOnScroll]="true"
                        [closeOnInteraction]="true" />
                }
                <ng-template #tooltip>
                    <ds-tooltip-content variant="utility">
                        <div slot="description">{{ item.toolTip }}</div>
                        <div slot="action">
                            <button
                                ds-button
                                variant="flat"
                                kind="tertiary"
                                [inverse]="true"
                                size="small"
                                (click)="goToCustomerCare()"
                                style="margin-left: auto">
                                Contact Customer Care
                            </button>
                        </div>
                    </ds-tooltip-content>
                </ng-template>
            </div>
        </div>
        <ds-divider class="wallet-balance-card__divider" vertical="false" variant="on-surface-lowest" />
        <div [vnDynamicHtml]="item.resources?.description" class="wallet-balance-card__description"></div>
        @if (item.children) {
            <div class="wallet-balance-card__subitems">
                @for (child of item.children; track trackByProp($index, child)) {
                    <ng-container *vnDynamicComponent="getItemComponent(child.type); attr: { item: child }" />
                    @if (!$last) {
                        <ds-divider></ds-divider>
                    }
                }
            </div>
        }
    </ds-card-content>
</ds-card>
